<template>
    <div>
        <section v-show="deleteConfirm" class="modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal__background"></div>
            <div class="modal__panel">
                <h3 class="modal__title">アカウントを削除しますか？<br>
                    この操作は取り消せません。</h3>
                <div class="modal__buttonArea">
                    <button @click.prevent="onCancel" class="button button--secondary">キャンセル</button>
                    <button @click.prevent="onOk" class="button button--primary">削除</button>
                </div>
            </div>
        </section>

        <section v-show="deleteComplete" class="modal">
            <div class="modal__background"></div>
            <div class="modal__panel">
                <h3 class="modal__title">TC IDを削除しました。</h3>
                <div class="modal__buttonArea">
                    <button @click.prevent="onCancel" class="button button--primary">閉じる</button>
                </div>
            </div>
        </section>

        <section v-show="reSendMail" class="modal">
            <div class="modal__background"></div>
            <div class="modal__panel">
                <h3 class="modal__title">確認メールを送信しました。<br>
                メールを開き、<br>
                リンクをクリックして下さい。</h3>
                <div class="modal__buttonArea">
                    <button @click.prevent="onCancel" class="button button--primary">閉じる</button>
                </div>
            </div>
        </section>

        <section v-show="sendMail" class="modal">
            <div class="modal__background"></div>
            <div class="modal__panel">
                <h3 class="modal__title">メールアドレスを変更しました。</h3>
                <div class="modal__buttonArea">
                    <button @click.prevent="onCancel" class="button button--primary">閉じる</button>
                </div>
            </div>
        </section>

        <section v-show="resetPassword" class="modal">
            <div class="modal__background"></div>
            <div class="modal__panel">
                <h3 class="modal__title">パスワードを変更しますか？</h3>
                <div class="modal__buttonArea">
                    <button @click.prevent="onCancel" class="button button--secondary">キャンセル</button>
                    <button @click.prevent="onOk" class="button button--primary">変更</button>
                </div>
            </div>
        </section>

        <section v-show="changePhone" class="modal">
            <div class="modal__background"></div>
            <div class="modal__panel">
                <h3 class="modal__title">認証用コード送信先が変更されました。</h3>
                <div class="modal__buttonArea">
                    <button @click.prevent="onCancel" class="button button--primary">閉じる</button>
                </div>
            </div>
        </section>

        <section v-show="smsDialog" class="modal">
            <div class="modal__background"></div>
            <div class="modal__panel">
                <h3 class="modal__title">10分以上の操作されていなかったため、もう一度やり直して下さい。</h3>
                <div class="modal__buttonArea">
                    <button @click.prevent="onOk" class="button button--primary">O K</button>
                </div>
            </div>
        </section>

        <section v-show="csrfErrDialog" class="modal">
            <div class="modal__background"></div>
            <div class="modal__panel">
                <h3 class="modal__title">30分以上の操作されていなかったため、もう一度やり直して下さい。</h3>
                <div class="modal__buttonArea">
                    <button @click.prevent="onOk" class="button button--primary">O K</button>
                </div>
            </div>
        </section>

        <section v-show="emailErrDialog" class="modal">
            <div class="modal__background"></div>
            <div class="modal__panel">
                <h3 class="modal__title">入力されたメールアドレスはすでに登録されています。</h3>
                <div class="modal__buttonArea">
                    <button @click.prevent="onOk" class="button button--primary">O K</button>
                </div>
            </div>
        </section>

        <section v-show="codeErrDialog" class="modal">
            <div class="modal__background"></div>
            <div class="modal__panel">
                <h3 class="modal__title">ワンタイムコードが正しくありません。</h3>
                <div class="modal__buttonArea">
                    <button @click.prevent="onOk" class="button button--primary">O K</button>
                </div>
            </div>
        </section>

        <section v-show="loading" class="modal">
            <div class="modal__background"></div>
            <img src="/img/loading.gif">
        </section>

    </div>
</template>

<script>
export default {
    name: 'Modals',
    data() {
        return {
            deleteConfirm: false,
            deleteComplete: false,
            sendMail: false,
            reSendMail: false,
            resetPassword: false,
            changePhone: false,
            smsDialog: false,
            csrfErrDialog: false,
            emailErrDialog: false,
            codeErrDialog: false,
            loading: false,
            params: {}
        }
    },
    /**
     * life cycle mounted
     */
    mounted() {
        this.$eventHub.$on('show-delete-confirm', this.show)
        this.$eventHub.$on('show-delete-complete', this.show)
        this.$eventHub.$on('show-send-mail', this.show)
        this.$eventHub.$on('show-resend-mail', this.show)
        this.$eventHub.$on('show-reset-password', this.show)
        this.$eventHub.$on('show-change-phone', this.show)
        this.$eventHub.$on('show-sms-message', this.show)
        this.$eventHub.$on('show-csrf-error-message', this.show)
        this.$eventHub.$on('show-email-error-message', this.show)
        this.$eventHub.$on('show-code-error-message', this.show)
        this.$eventHub.$on('show-loading', this.show)
    },
    methods: {
        /**
         * show modal
         * 
         * @params {*} params
         */
        show(params) {
            // eventのタイプ/resolve/rejectの3つがパラメータで渡される
            this.params = params
            switch (params.type) {
                case 'show-delete-confirm':
                    this.deleteConfirm = true
                    break;
                case 'show-delete-complete':
                    this.deleteComplete = true
                    break;
                case 'show-send-mail':
                    this.sendMail = true
                    break;
                case 'show-resend-mail':
                    this.reSendMail = true
                    break;
                case 'show-reset-password':
                    this.resetPassword = true
                    break;
                case 'show-change-phone':
                    this.changePhone = true
                    break;
                case 'show-sms-message':
                    this.smsDialog = true
                    break;
                case 'show-csrf-error-message':
                    this.csrfErrDialog = true
                    break;
                case 'show-email-error-message':
                    this.emailErrDialog = true
                    break;
                case 'show-code-error-message':
                    this.codeErrDialog = true
                    break;
                case 'show-loading':
                    this.loading = true
                default:
                    break;
            }
        },
        /**
         * 削除や送信などのOK系ボタン
         */
        onOk() {
            this.close()
            this.params.resolve()
        },
        /**
         * キャンセルボタン
         */
        onCancel() {
            this.close()
        },
        /**
         * 全てのモーダルダイアログをcloseする.
         */
        close() {
            this.deleteConfirm = false
            this.deleteComplete = false
            this.sendMail = false
            this.reSendMail = false
            this.resetPassword = false
            this.changePhone = false
            this.smsDialog = false
            this.csrfErrDialog = false
            this.emailErrDialog = false
            this.codeErrDialog = false
            this.loading = false
        }

    },
}
</script>

<style scoped></style>
